module.exports = __webpack_public_path__ + "static/WS_appflows_fisica_6-f8c7ba13b6e645818fd7df68191cb000.gif";